module.exports = __webpack_public_path__ + "static/media/apple_cranberry_toast.b145b9e2.png";